"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _olapic = require("./olapic");
Object.keys(_olapic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _olapic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _olapic[key];
    }
  });
});
var _ObjectWithId = require("./ObjectWithId");
Object.keys(_ObjectWithId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ObjectWithId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ObjectWithId[key];
    }
  });
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
